















































































































	import { Vue, Component } from "vue-property-decorator";
	import CardTitle from "../../components/CardTitle.vue";
	import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
	import * as user from "../../_store/user.module";
	import * as data from "../../_store/data.module";
	import { bus } from "../../main";
	import { userUtils } from "../../_utils/userUtils";
	import * as auth from "../../_store/auth.module";
	import { createFileRendicontoPCTO, createFileStatisticheAttivita } from "../../_utils/excelUtils";
	import * as temp from "../../_store/temp.module";
	import { ParametriPCTO, validaParametriPCTO } from "../../_utils/rendicontoPCTO";

@Component({
	components: {
		CardTitle,
		DetailsDataTable
	}
})

export default class Statistiche extends Vue {
	private titleParams: object;

	private loadingRendicontazionePCTO: boolean = false;
	private loadingAttivitaReport: boolean = false;
	private loadingAnniScolastici: boolean = false;

	private parametriPCTO: ParametriPCTO = {
        oreDisponibili: 545,
        coefficienteSettore: 0.12,
        coefficienteArticolazione: 0.50,
        coefficientePresenza: 0.55,
        coefficienteDistanza: 0.20,
        modalitaMonitoraggi: 'eventi',
        tutorSettore: {}
    };
	private datiReportAttivita: any[] = [];
    private dialogPCTO = false;
    private recordsetsPCTO: any[] = [];
    private annoReportPCTO = 0;
    private totaleAbbinamentiPCTO = 0;
    private settoriPCTO: Array<{ id: number; nome: string }> = [];
    private docentiPCTO: Array<{ id: number; nome: string }> = [];

    get tutorSettoreCompleti() {
        return this.settoriPCTO.length > 0 && this.settoriPCTO.every(s => this.parametriPCTO.tutorSettore && this.parametriPCTO.tutorSettore[s.id]);
    }

	private anniScolastici: any[] = [];
	private selectedAnnoScolastico: number | null = null;

	constructor() {
		super();
		this.titleParams = {
			title: "Statistiche",
			cols: "12",
			sm: "5",
			md: "5",
			lg: "4"
		};
	}

	async downloadRendicontazionePCTOReport() {
        this.loadingRendicontazionePCTO = true;
        try {
            validaParametriPCTO(this.parametriPCTO);
            const anno = Number(this.selectedAnnoScolastico);
            if (!Number.isInteger(anno) || anno <= 0) throw new Error('Selezionare un anno scolastico.');
            const instituteInfo = user.readInstituteInfo(this["$store"]);
            const result = await data.dispatchDownloadRendicontazionePCTOReport(this["$store"], {
                idAnnoScolastico: anno, idIstituto: instituteInfo.id
            });
            if (!Array.isArray(result) || result.length !== 5 || result.some(s => !Array.isArray(s)) || !result[0][0] || result[0][0].Versione !== 1) {
                throw new Error('Aggiornare la procedura di rendicontazione PCTO.');
            }
            if (!result[1].length) throw new Error('Nessun abbinamento PCTO disponibile per l’anno selezionato.');
            this.recordsetsPCTO = result;
            this.annoReportPCTO = anno;
            this.totaleAbbinamentiPCTO = result[0][0].AbbinamentiTotali;
            const settori = new Map<number, string>();
            const docenti = new Map<number, string>();
            result[1].forEach((b: any) => {
                settori.set(b.IdSettore, b.Settore || 'Settore non disponibile');
                if (b.IdTutorArticolazione && b.TutorArticolazione.trim()) docenti.set(b.IdTutorArticolazione, b.TutorArticolazione);
                if (b.IdTutorFormativo && b.TutorFormativo.trim()) docenti.set(b.IdTutorFormativo, b.TutorFormativo);
            });
            result[2].forEach((t: any) => docenti.set(t.IdDocente, t.Docente));
            this.settoriPCTO = Array.from(settori, ([id, nome]) => ({ id, nome })).sort((a, b) => a.nome.localeCompare(b.nome, 'it'));
            this.docentiPCTO = Array.from(docenti, ([id, nome]) => ({ id, nome })).sort((a, b) => a.nome.localeCompare(b.nome, 'it'));
            const scelte: { [id: string]: number } = {};
            this.settoriPCTO.forEach(s => {
                const candidati = result[2].filter((t: any) => t.IdSettore === s.id);
                if (candidati.length === 1) scelte[s.id] = candidati[0].IdDocente;
                else scelte[s.id] = 0;
            });
            this.parametriPCTO.tutorSettore = scelte;
            this.dialogPCTO = true;
        } catch (error) {
            bus.$emit("errorOperation", error.response ? "Impossibile recuperare i dati PCTO. Verificare che la procedura di rendicontazione sia installata." : error.message || "Errore durante il download del report PCTO");
        } finally {
            this.loadingRendicontazionePCTO = false;
        }
    }

    async esportaRendicontazionePCTO() {
        this.loadingRendicontazionePCTO = true;
        try {
            await createFileRendicontoPCTO(this.recordsetsPCTO, 'Rendiconto_PCTO_' + this.annoReportPCTO, this.parametriPCTO, this.annoReportPCTO);
            this.dialogPCTO = false;
            bus.$emit('successfullOperation', 'Report PCTO scaricato. Verificare il foglio Controlli.');
        } catch (error) {
            bus.$emit('errorOperation', error.message || 'Errore nella creazione del report PCTO');
        } finally {
            this.loadingRendicontazionePCTO = false;
        }
    }

	async loadAnniScolastici() {
		await data
			.dispatchAnniScolastici(this["$store"])
			.then(result => {
				result.forEach((element: any) => {
					this.anniScolastici = result
				});
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	async downloadAttivitaReport() {
		this.loadingAttivitaReport = true;
		try {
			var idAnnoScolastico = parseInt(this.selectedAnnoScolastico as unknown as string);
			var instituteInfo = user.readInstituteInfo(this["$store"]);

			var payload = {
				idAnnoScolastico: idAnnoScolastico,
				idIstituto: instituteInfo.id
			}

			await data.dispatchDownloadAttivitaReport(this["$store"], payload)
				.then(async (result: any) => {
					await createFileStatisticheAttivita(result, 'Statistiche_Attivita' );

					bus.$emit("successfullOperation", "Report attività scaricato con successo");
					this.loadingAttivitaReport = false;
				})
				.catch((error: any) => {
					throw error;
				})
		} catch (error) {
			bus.$emit("errorOperation", "Errore durante il download del report attività");
			this.loadingAttivitaReport = false;
		}
	}

	created() {
		var token = localStorage.getItem("userToken");
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
		user
			.dispatchSetUserInfo(this["$store"], payload)
			.then(() => {
				user
					.dispatchSetInstituteInfo(this["$store"])
					.then(async () => {
						await this.loadAnniScolastici();

						this.selectedAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
						bus.$emit("loadMenu");
					})
					.catch(() => {
						bus.$emit("stopLoading");
						auth.dispatchLogout(this["$store"]);
						user.dispatchClearState(this["$store"]);
						this["$router"].push("/sessionExpired");
					});
			})
			.catch(() => {
				bus.$emit("stopLoading");
				auth.dispatchLogout(this["$store"]);
				user.dispatchClearState(this["$store"]);
				this["$router"].push("/sessionExpired");
			});
	}
}
